import { call, fork, put, take } from 'redux-saga/effects';
import {UpdateLocationPayload, updateLocation} from '../action/locationsCommands';
import {Action} from 'redux-actions';
import {enqueueErrorSnackbar, enqueueSuccessSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import {Api} from '../api';
import Logger from '../common/logger';
import {locationUpdated} from '../action/locationsEvents';

export const onUpdateLocation = function*(data: UpdateLocationPayload) {
    try {
        yield call(
            Api.updateLocation,
            {
                id: data.id,
                enabled: data.enabled,
                status: data.status,
            },
        );

        yield put(enqueueSuccessSnackbar({
            message: getI18n().t('snackbar.success.update_location'),
        }));

        yield put(locationUpdated(data));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({
            message: getI18n().t('snackbar.error.update_location'),
        }));
    }
};

export function* updateLocationFlow() {
    while (true) {
        const action: Action<UpdateLocationPayload> = yield take(updateLocation.toString());
        yield fork(onUpdateLocation, action.payload);
    }
}
